// This file MUST be imported FIRST in index.jsx
// It sets up global variables required by legacy jQuery plugins like bootstrap-daterangepicker
import moment from 'moment';
import jQuery from 'jquery';

// Expose moment and jQuery globally for bootstrap-daterangepicker
if (globalThis.window !== undefined) {
    globalThis.moment = moment;
    globalThis.$ = globalThis.jQuery = jQuery;
}
